


import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import { UserService } from 'src/app/services/user/user.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-clients-stadistic-auth',
  templateUrl: './clients-stadistic-auth.component.html',
  styleUrls: ['./clients-stadistic-auth.component.css']
})
export class ClientsStadisticAuthComponent implements OnInit {


  loading:any;
  shop:any;
  stadistic:any;
  shops:any;
  shops_obj:any;
  stepsObj: any ={};
  stepObjData: any ={};

  steps: any ={};
  reloadStadistic:any;
  reloadStadisticLoading:any;
  client_stadistic:any;

  // Propiedades para el control de registro
  registrationConfig: any = null;
  registrationConfigLoading: boolean = false;
  showRegistrationModal: boolean = false;
  registrationModalLoading: boolean = false;
  registrationMessageForm: string = '';
  registrationMessageError: string = '';


  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    public socketService: SocketioService,
    public _auth: AuthService
  ) { }



  ngOnInit(): void {
    

    if(localStorage.getItem('client-stadistic')){

      let jsta:any = localStorage.getItem('client-stadistic');

      const client_stadistic = JSON.parse(jsta);

      this.stadistic = client_stadistic?.stadistic;

      this.client_stadistic = client_stadistic;


    }else{

        this.stadisticGet()


    }

    // Cargar configuración de registro
    this.loadRegistrationConfig();
     

  }


  stadisticGet = async (init= true) => {
    try {

      if(init){
        this.loading = true;

      }else{
        this.reloadStadisticLoading = true;

      }

      const resp = await this.getStadisticServer();
     this.stadistic = resp?.resp;

     const client_stadistic = {
      date:new Date(),
      stadistic:resp?.resp


     }
     this.client_stadistic = client_stadistic;

     const cadenaJSON = JSON.stringify(client_stadistic);

     localStorage.setItem('client-stadistic',cadenaJSON)


        
    } catch (error) {
      console.error(error);



    } 
    this.loading = false;
    this.reloadStadisticLoading = false;

   


  }



  getStadisticServer = async () => {
    try{
        return this._user.clientStadistic({});

      } catch (error) {
        console.error(error);
        
    
      }
  }

  /**
   * Cargar la configuración actual del registro de usuarios
   */
  loadRegistrationConfig = async () => {
    try {
      this.registrationConfigLoading = true;
      const response = await this._user.getRegistrationConfig();
      
      if (response && response.data) {
        this.registrationConfig = {
          params: {
            enable: response.data.enable,
            text: response.data.text
          }
        };
        this.registrationMessageForm = response.data.text || '';
      }
      
      console.log('Configuración de registro cargada:', this.registrationConfig);
    } catch (error) {
      console.error('Error al cargar configuración de registro:', error);
      // Configuración por defecto en caso de error
      this.registrationConfig = {
        params: {
          enable: true,
          text: 'Estimado usuario, en estos momentos no te puedes registrar'
        }
      };
    } finally {
      this.registrationConfigLoading = false;
    }
  }

  /**
   * Abrir el modal de configuración de registro
   */
  openRegistrationModal = () => {
    this.showRegistrationModal = true;
    this.registrationMessageError = '';
    // Actualizar el formulario con el mensaje actual
    this.registrationMessageForm = this.registrationConfig?.params?.text || '';
  }

  /**
   * Cerrar el modal de configuración de registro
   */
  closeRegistrationModal = () => {
    this.showRegistrationModal = false;
    this.registrationMessageError = '';
  }

  /**
   * Alternar el estado del registro (activar/desactivar)
   */
  toggleRegistration = async () => {
    try {
      this.registrationModalLoading = true;
      
      const newState = !this.registrationConfig.params.enable;
      const response = await this._user.toggleUserRegistration(newState);
      
      if (response && response.ok && response.data) {
        this.registrationConfig = {
          params: {
            enable: response.data.enable,
            text: response.data.text
          }
        };
        
        // No mostrar notificación de éxito, solo actualizar el estado visual
      }
    } catch (error) {
      console.error('Error al cambiar estado del registro:', error);
      this.showNotification('❌ Error al cambiar el estado del registro', 'error');
    } finally {
      this.registrationModalLoading = false;
    }
  }

  /**
   * Guardar el mensaje de registro
   */
  saveRegistrationMessage = async () => {
    try {
      // Validar que el mensaje no esté vacío
      if (!this.registrationMessageForm || this.registrationMessageForm.trim().length === 0) {
        this.registrationMessageError = 'El mensaje no puede estar vacío';
        return;
      }

      this.registrationModalLoading = true;
      this.registrationMessageError = '';
      
      const response = await this._user.updateRegistrationMessage(this.registrationMessageForm);
      
      if (response && response.ok && response.data) {
        this.registrationConfig = {
          params: {
            enable: response.data.enable,
            text: response.data.text
          }
        };
        this.showNotification('✅ Mensaje actualizado exitosamente', 'success');
      }
    } catch (error) {
      console.error('Error al actualizar mensaje:', error);
      this.showNotification('❌ Error al actualizar el mensaje', 'error');
    } finally {
      this.registrationModalLoading = false;
    }
  }

  /**
   * Mostrar notificación al usuario
   */
  showNotification = (message: string, type: 'success' | 'error') => {
    // Usando alertify si está disponible
    if (typeof (window as any).alertify !== 'undefined') {
      if (type === 'success') {
        (window as any).alertify.success(message);
      } else {
        (window as any).alertify.error(message);
      }
    } else {
      // Fallback a console si alertify no está disponible
      console.log(`[${type.toUpperCase()}] ${message}`);
      alert(message);
    }
  }

  
  
}
